export default {
    msg: {
        videoMonitoring: 'Видеонаблюдение',
        feedback: 'Обратная связь',
        date: 'Дата',
        cameras: 'Камеры',
        byDay: 'за день',
        records: 'Записи',
        hour: 'Час',
        login: 'Логин',
        password: 'Пароль',
        toLogin: 'Войти',
        loginAuth: 'Авторизация',
        invalidLoginOrPassword: 'Неправильный логин или пароль',
        server: 'Сервер',
        serverLoad: 'Нагрузка',
        diskFree: 'Свободно на диске',
        memoryFree: 'Свободно памяти',
        uptime: 'Время работы',
        usedOf: 'занято из',
        withoutRestart: 'без перезагрузки',
        daysShort: 'дн.',
        hoursShort: 'ч.',
        minutesShort: 'мин.',
        archiveForDay: 'Архив за день',
        cpuLoad: 'Загрузка CPU',
        free: 'свободно',
        archiveHistory: 'История',
        recording: 'Идёт запись',
        streamLoading: 'Подключаемся к камере…',
        streamUnavailable: 'Поток временно недоступен',
        streamReconnecting: 'Повторное подключение…',
        retry: 'Повторить'
    },
    validation: {
        messages: {
            _default: 'not valid',
            required: 'is required',
            max: 'max length {1}',
            url: 'url is not valid',
            decimal: 'not decimal',
            numeric: 'not numeric',
            min_value: 'min value {1}',
            max_value: 'max value {1}',
            char_name: 'available chars: a-z A-Z 0-9 - _ .',
            repeat_password: 'passwords do not match'
        }
    },
    $vuetify: {
        dataTable: {
            itemsPerPageText: 'Rows per page',
            ariaLabel: {
                sortNone: 'Sort none',
                sortAscending: 'Sort ascending',
                sortDescending: 'Sort descending'
            }
        },
        dataFooter: {
            pageText: '{0}-{1} of {2}',
            itemsPerPageAll: 'All',
            prevPage: 'Prev page',
            nextPage: 'Next page'
        },
        dataIterator: {
            loadingText: 'Loading...'
        },
        noDataText: 'No data',
        datePicker: {
            itemsSelected: '{0} selected'
        }
    }
}
